export default "__VITE_ASSET__1a5d5893__"